import React from 'react'
import {Icon} from '@chakra-ui/react'

const PlayBiggerIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path d="M28.8 24L22.4 19.2V28.8L28.8 24Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48 24C48 37.2549 37.2547 48 23.9995 48C10.7445 48 0 37.2551 0 24C0 10.7449 10.7445 0 23.9995 0C37.2547 0 48 10.7451 48 24ZM46.4 24C46.4 36.3713 36.3711 46.4 23.9995 46.4C11.6282 46.4 1.6 36.3715 1.6 24C1.6 11.6285 11.6282 1.6 23.9995 1.6C36.3711 1.6 46.4 11.6287 46.4 24Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default PlayBiggerIcon
